import React from 'react';
import { motion } from 'framer-motion';
export function LeadSection() {
  return <section className="bg-slate-800 py-20 px-4 text-slate-200" data-id="element-57">
      <div className="max-w-2xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl leading-relaxed font-light" data-id="element-59">
          <p data-id="element-60">
            <span className="text-amber-400 font-serif text-2xl block mb-2" data-id="element-61">
              Querida amiga,
            </span>
            Estás mirando el techo otra vez. El silencio de la casa se siente
            pesado. Tu mente no para: repasas la lista de mañana, te preocupas
            por tus hijos, o simplemente sientes ese vacío molesto de no poder
            cerrar los ojos.
          </p>

          <p className="italic text-slate-300 border-l-4 border-amber-500/30 pl-6 py-2" data-id="element-62">
            Mañana te espera la misma fatiga de siempre. Ese cansancio que te
            quita las ganas de salir, de jugar con tus nietos, o de disfrutar un
            café con amigas.
          </p>

          <p data-id="element-63">
            Miras el reloj.{' '}
            <strong className="text-white font-medium" data-id="element-64">3:14 AM.</strong>
          </p>

          <p data-id="element-65">
            Te preguntas si alguna vez volverás a sentirte descansada de verdad.
            Si esa energía que tenías a los 40 se fue para siempre.
          </p>

          <p data-id="element-66">
            Sé exactamente cómo se siente, porque he estado ahí. Y quiero
            decirte algo importante:{' '}
            <span className="text-amber-400 font-medium" data-id="element-67">
              No estás sola en esto.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}